import Admin from './Admin';
export {default as Categories} from './Categories';
export {default as Importer} from './Importer';
export {default as Questions} from './Questions';
export {default as Quizzes} from './Quizzes';
export default Admin;
